<template>
  <div v-loading="validating">
    <ImgUpload
      :file="value"
      ref="imgs"
      @upload-success="(url) => onChange(url)"
      @del="() => onChange('')"
      :fixImgCache="fixImgCache"
      v-bind="extraAttr"
      :isSingle="true"
    />
    <div class="tips" v-if="tips">
      {{tips}}
    </div>
  </div>
</template>

<script>
import ImgUpload from '@/components/Uploads/ImgUpload'

export default {
  components: {
    ImgUpload
  },
  props: ['props', 'value'],
  data() {
    return {
      validating: false,
      hasSizeError:false,
      fixImgCache:{}, // 一键修改图片后缓存一下老的图片, key:新地址 value: 老地址
    }
  },
  computed: {
    tips() {
      return this.props.tips || ''
    },
    extraAttr() {
      return this.props.extraAttr || {}
    }
  },
  methods: {
    onChange(v) {
        this.$emit('change', v)
        if (this.extraAttr._needLimit) {
          setTimeout(() => {
            this.$refs.imgs.elFormItem && this.$refs.imgs.elFormItem.elForm.validateField(this.$refs.imgs.elFormItem.prop)
          }, 800);
        }
    },
  },
  mounted() {
    const watcher = this.$watch('extraAttr', (v) => {
      if (v._needLimit && this.$refs.imgs) {
        this.$parent.rules.push({
          validator: async (rule, value, callback) => {
            if (this.validating) {
              return callback(new Error('图片校验中'))
            }
            this.validating = true
            let errMsg = await this.$refs.imgs.method_validImage()
            if (errMsg) {
                const regex = /宽度|长度|长宽/;
                if(regex.test(errMsg)){
                  this.hasSizeError = true
                }else{
                  this.hasSizeError = false
                }
                callback(new Error(errMsg));
            } else {
                this.hasSizeError = false
                callback();
            }
            this.validating = false
          }
        })
      }
      this.$nextTick(() => {
        watcher && watcher();
      })
    }, {
      immediate: true
    })
  }
}
</script>

<style lang="scss" scoped>
.tips {
  font-size: 12px;
  color: #a5a5a5;
}
</style>